/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module IPReputationDBModule
 * @preferred
 */

import angular from 'angular';
import { initAjsDependency } from 'ajs/js/utilities/ajsDependency';
import {
    IPReputationDB,
    IPReputationDBCollection,
} from '.';

const ipReputationDBModule = angular.module('avi/ip-reputation-db');
const factories = [
    {
        dependency: IPReputationDB,
        name: 'IPReputationDB',
    },
    {
        dependency: IPReputationDBCollection,
        name: 'IPReputationDBCollection',
    },
];

factories.forEach(({ name, dependency }) => {
    initAjsDependency(ipReputationDBModule, 'factory', name, dependency);
});
